export const AUTH_COOKIE_NAME = 'evaneos_auth_token';

const ONE_YEAR_IN_SECONDS = 31536000;

type AuthCookieOptions = {
    httpOnly: boolean;
    secure: boolean;
    sameSite: 'lax';
    path: string;
    maxAge: number;
};

type AuthCookieSetter = {
    set: (name: string, value: string, options: AuthCookieOptions) => unknown;
};

export function setAuthCookie(cookies: AuthCookieSetter, jwt: string): void {
    cookies.set(AUTH_COOKIE_NAME, jwt, {
        httpOnly: true,
        secure: true,
        sameSite: 'lax',
        path: '/',
        maxAge: ONE_YEAR_IN_SECONDS,
    });
}
